import { FormKey } from '../../enums/formKey';
import { StepKey } from '../../enums/stepKey';
import { ApplianceModel } from '../../models/services/api/queryModelNumber';
import { ApplianceFormData } from '../../store/store.types';

export const getFormApplianceName = (
  formData: ApplianceFormData,
  applianceModels: ApplianceModel[] | undefined,
): string | undefined => {
  const formItemTypeCode = formData[StepKey.APPLIANCE_DETAILS]?.[FormKey.ITEM_CATEGORY];
  return applianceModels?.find((model) => model.itemTypeCode === formItemTypeCode)?.applianceName;
};
